<template>
  <div class="partial-block-video" :style="videoRegion">
    <div  v-if="fileFormat==='svg'">
      <object ref="svgObject" :data="source" type="image/svg+xml"></object>
      <div class="click-overlay" :style="clickRegion" @click.stop="handleClick"></div>
   </div>
    <!--video-element :sources="[source]" :autoplay="true" :loop="true" :loop-count="4" :delay="1"   :poster="posterSource" @click.stop="handleClick" playsinline muted / -->
    <video v-else ref="pVideo" :autoplay="isAutoplay"  @ended="handleDelay"  :poster="posterSource" @click.stop="handleClick" playsinline muted>
      <source :src="source" type="video/mp4" />
      <source :src="source" type="video/webm" />
    </video>

    <div class="buttons_set custom_controls" v-if="isMobileAndTablet ? mobileControls : showControls" :style="inverseScaling">
      <img :src="playBtnIcon" tabindex="0" @click="toggleVideoPlay" alt="" :style="inverseImgScaling">
      <img class="audioBtn" v-if="hasAudio" :src="muteBtnIcon" tabindex="0" @click="toggleVideoMute"
           alt="" :style="inverseImgScaling">
      <img class="closeBtn" src="/icons/in-block-video/close.svg" tabindex="0"
           @click="closeInBlockVideo" alt="close" :style="inverseImgScaling">
    </div>
  </div>
</template>

<script>
import featureMixin from "@/mixins/featureMixin";
import blockElementMixin from "@/mixins/blockElementMixin";
import InblockVideosMixin from "@/features/inblock-videos/InblockVideosMixin";
import {mapGetters} from "vuex";
import VideoElement from "@/components/graphics/VideoElement.vue";


export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { VideoElement },
  mixins: [featureMixin, blockElementMixin,InblockVideosMixin],
  props: {
    posterSource: String,
  },
  data() {
    return {
      videoPlaying: true,
      videoMuted: true,
      videoRegion: {},
      clickRegion: {},
      featurePath: 'blockVideos.fullBlock',
    }
  },
  mounted() {
    const v = this.$refs.pVideo;

    this.handleVideoRegion();
    v?.play()

    // Hide Picture-In-Picture on hover in MS Edge
    if(window.navigator.userAgent.indexOf("Edg")> -1){
      v.setAttribute('disablePictureInPicture', true);
      v.setAttribute('controlsList','nodownload')
    }

    this.$emit('pVideoStarted')
  },
  methods:{
    play() {
      this.$refs.pVideo.play();
    },
    pause() {
      this.$refs.pVideo.pause();
    },
    onVideoEvent() {
      const video = this.$refs.pVideo;
      this.videoPlaying = !video.paused;

    },
    handleVideoRegion() {

    if (this.fileFormat) {
          this.videoRegion = {
          left: `${this.isVideo.clickRegions[0]?.left}%`,
          top: `${this.isVideo.clickRegions[0]?.top}%`,
          width: `${this.isVideo.clickRegions[0]?.width}%`,
          height: `${this.isVideo.clickRegions[0]?.height}%`,
          zIndex:'99999',
          position:'absolute',
        };
        } else {
          this.videoRegion = {
            left: `${this.isVideo.videoRegions[0]?.left}%`,
          top: `${this.isVideo.videoRegions[0]?.top}%`,
          width: `${this.isVideo.videoRegions[0]?.width}%`,
          height: `${this.isVideo.videoRegions[0]?.height}%`,
          zIndex:'99999',
          position:'absolute',
        };
        }
        if(this.fileFormat === 'svg') {
      this.clickRegion = {
          left: `0`,
          top: `0`,
          width: `100%`,
          height: `100%`,
          zIndex:'99999',
          position:'absolute',
        };
        return;
    }
    },
    toggleVideoPlay() {
      const isPlaying = !this.$refs.pVideo.paused;
      this.videoPlaying = !isPlaying;
      if (isPlaying) {
        this.pause();
      }
      else
        this.play();
    },
    toggleVideoMute() {
      const video = this.$refs.pVideo;
      this.videoMuted = !video.muted;
      video.muted = !video.muted;
      /*let vid = document.getElementById(`${this.id}`);
            !this.videoMuted ?  vid.muted=true : vid.muted=false*/
    },
    closeInBlockVideo() {
      this.$emit('pHandleUserClose')
    },
    handleDelay() {
      this.$emit('pVideoEnded')
    }
  },
  computed: {
    ...mapGetters('screen', [ 'isMobileAndTablet']),
    ...mapGetters(['isCTC', 'isJC']),
  }
}
</script>

<style scoped lang="scss">
.partial-block-video {
  position: relative;
  height:100%;

  object {
      display: block;
      .click-overlay {
      position: absolute;
      background: transparent;
     }
   }


  >.buttons_set {
    bottom: 0;
    width: 100%;
    z-index: 1005;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 10%;
    padding: 0 10px;
    background: rgba(0, 0, 0, 0.5);
    transition: opacity 300ms;
    //transition-delay: 2s;
    opacity: 0;
    font-size: 16px;
    position:absolute;

    //&:hover{
    //  transition-delay: unset;
    //  opacity: 1;
    //}
    img {
      max-height: 80%;
      height: auto
    }

    img.audioBtn {
      margin-left: 10px;
    }


  }
  >.buttons_set.custom_controls {
    height: 44px !important;
    img {
      width: auto;
      height: auto
    }
  }

  &:hover>.buttons_set {
    transition-delay: unset;
    opacity: 1;
  }

  .buttons_set img {
    cursor: pointer;
    left: 10%;
    margin-left: 10px;
    pointer-events: all;
  }
  .buttons_set.customMetro img {
    margin-left: 16px;
    pointer-events: all;
  }

  .closeBtn {
    border-radius: 50px;
    // background-color: red;\
    margin-right: 10px;
    border: none;
    margin-left: auto !important;
    right: 5% !important
  }

  video {
    width: 100%;
    height: 100%;
    background: transparent;
    object-fit: cover !important;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
  }
}
.partial-block-video.pop-video {
  &:hover,
  &:focus {
    transform: scale(1.02);
    box-shadow: 0 0 50px rgba(0, 0, 0, 0.3);
    z-index: 9999;
    outline: none;
  }
}
</style>
